import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const MasterCardIcon = (props: IconProps) => (
  <StyledIcon
    width="33"
    height="22"
    viewBox="0 0 33 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="33" height="22" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.75 16.1569C15.5584 17.1852 14.0128 17.806 12.3238 17.806C8.55511 17.806 5.5 14.7154 5.5 10.903C5.5 7.09057 8.55511 4 12.3238 4C14.0128 4 15.5584 4.62075 16.75 5.64903C17.9416 4.62075 19.4872 4 21.1762 4C24.9449 4 28 7.09057 28 10.903C28 14.7154 24.9449 17.806 21.1762 17.806C19.4872 17.806 17.9416 17.1852 16.75 16.1569Z"
      fill="#ED0006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.75 16.1569C18.2172 14.8908 19.1475 13.0068 19.1475 10.903C19.1475 8.79917 18.2172 6.91517 16.75 5.64903C17.9416 4.62075 19.4872 4 21.1762 4C24.9449 4 28 7.09057 28 10.903C28 14.7154 24.9449 17.806 21.1762 17.806C19.4872 17.806 17.9416 17.1852 16.75 16.1569Z"
      fill="#F9A000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.75 5.64906C18.2172 6.9152 19.1475 8.79919 19.1475 10.903C19.1475 13.0068 18.2172 14.8908 16.75 16.1569C15.2828 14.8908 14.3525 13.0068 14.3525 10.903C14.3525 8.79919 15.2828 6.9152 16.75 5.64906Z"
      fill="#FF5E00"
    />
  </StyledIcon>
)
